import { Component, computed, input, signal } from '@angular/core';
import type { OnInit } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import type { FormControl } from '@angular/forms';

import { map, startWith, switchMap } from 'rxjs';

import type { RatingScale } from '@core/candidate-evaluation-settings-types';
import { TranslatePipe } from '@core/i18n-legacy';
import type { EditorJSONState } from '@core/prosemirror-types';
import { BoxComponent, ButtonComponent, IconComponent } from '@core/user-interface-legacy';
import { EvaluationRatingFieldComponent } from '@recruitee/evaluations-ui';

import { EvaluationCommentFieldComponent } from '../evaluation-comment-field/evaluation-comment-field.component';

@Component({
  selector: 'rt-evaluation-rating-advanced-field',
  templateUrl: './evaluation-rating-advanced-field.component.html',
  styleUrls: ['./evaluation-rating-advanced-field.component.less'],
  imports: [
    BoxComponent,
    ButtonComponent,
    IconComponent,
    TranslatePipe,
    EvaluationRatingFieldComponent,
    EvaluationCommentFieldComponent,
  ],
})
export class EvaluationRatingAdvancedFieldComponent implements OnInit {
  public readonly ratingControl = input.required<FormControl<number | null>>();
  public readonly commentControl = input.required<FormControl<string | null>>();
  public readonly commentJsonControl = input.required<FormControl<EditorJSONState | null>>();
  public readonly ratingScale = input<RatingScale | null>(null);
  public readonly showValidationErrors = input<boolean>(false);

  protected commentExpanded = signal(false);

  protected isRatingInvalid = toSignal(
    toObservable(this.ratingControl).pipe(
      switchMap(control =>
        control.events.pipe(
          map(() => control.invalid),
          startWith(control.invalid),
        ),
      ),
    ),
    { initialValue: false },
  );

  protected hasError = computed(() => this.showValidationErrors() && this.isRatingInvalid());

  public ngOnInit(): void {
    if (this.commentControl().value || this.commentJsonControl().value) {
      this.commentExpanded.set(true);
    }
  }

  protected expandComment(): void {
    this.commentExpanded.set(true);
  }
}
